export default "__VITE_ASSET__90054808__"